import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-view-image-dialog",
  templateUrl: "./view-image-dialog.component.html",
  styleUrls: ["./view-image-dialog.component.scss"],
})
export class ViewImageDialogComponent implements OnInit {
  image: string = "";
  host: string = "";
  constructor(private dialog: NgbActiveModal) {}

  ngOnInit(): void {
    // this.host = environment.baseUrl;
  }

  close(): void {
    this.dialog.close();
  }
}
